var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    rx: 9.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.222 6.08811C13.3891 5.92108 13.6631 5.92273 13.8284 6.08811L14.3763 6.63499C14.5417 6.80037 14.5416 7.07705 14.3763 7.24241L8.7054 12.9123C8.60052 13.0172 8.45213 13.0556 8.31477 13.0276C8.22794 13.0141 8.14405 12.9769 8.07845 12.9114L4.62434 9.45628C4.45962 9.29118 4.45749 9.01684 4.62434 8.84983L5.1722 8.30198C5.33923 8.13532 5.61159 8.13536 5.77864 8.30198L8.39192 10.9162L13.222 6.08811Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.74c8d8a6d38dc488bd8fac11d7355e83.svg";
export { ForwardRef as ReactComponent };